const config = {
  apiUrl: process.env.REACT_APP_REPORT_SERVICE_API,
  gptServiceUrl: process.env.REACT_APP_GPT_SERVICE_API,
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export default config;